import * as React from 'react';
import styles from './styles.module.styl';
export var Hero = function () { return (React.createElement("div", { className: styles.quickstartsHero },
    React.createElement("div", { className: styles.quickstartsHeroTitle },
        React.createElement("h1", null, "Quickstarts"),
        React.createElement("p", null, "Step-by-step guides to quickly integrate Auth0 into your application")),
    React.createElement("div", { className: styles.quickstartsHeroImage },
        React.createElement("img", { src: "/docs/img/quickstarts/header_img.svg", alt: "quickstarts header" })))); };
